const translations = {
  header: {
    about: 'Professional Profile',
    experience: 'Professional Experience',
    projects: 'Significant Projects',
    skills: 'Technical Skills',
    education: 'Education',
    role: {
      frontend: 'Frontend Developer',
      backend: 'Backend Developer',
      fullstack: 'Full Stack Developer',
    }
  },
  profile: {
    select: 'Select Profile',
    backend: 'Backend',
    frontend: 'Frontend',
    fullstack: 'Full Stack'
  },
  summary: {
    title: 'About',
    description: {
      backend: 'Backend Developer with experience in Node.js, TypeScript, Fastify, and PostgreSQL. Develops REST APIs with Clean Architecture, DDD, and automated testing. Experience with Drizzle ORM, Prisma, and service integration. Focused on code quality and scalable architecture.',
      frontend: 'Frontend Developer with experience in React, Next.js, TypeScript, and TailwindCSS. Builds responsive and accessible interfaces with a focus on performance and SEO. Experience with PWA, E2E testing (Playwright), and Design Systems. Committed to user experience and clean code.',
      fullstack: 'Full Stack Developer with experience in React, Node.js, and TypeScript. Builds end-to-end applications using Next.js, Fastify, PostgreSQL, and modern practices. Experience with PWA, gamification, LGPD compliance, automated testing, and CI/CD. Committed to clean code, Clean Architecture, and continuous learning.'
    }
  },
  skills: {
    title: 'Skills',
    languages: 'Languages',
    reactjs: 'React.js',
    nextjs: 'Next.js',
    typescript: 'TypeScript',
    tailwindcss: 'TailwindCSS',
    html5: 'HTML5',
    css3: 'CSS3',
    javascript: 'JavaScript',
    'react-native': 'React Native',
    nodejs: 'Node.js',
    expressjs: 'Express.js',
    nestjs: 'NestJS',
    fastify: 'Fastify',
    postgresql: 'PostgreSQL',
    'jwt-auth': 'JWT Authentication',
    docker: 'Docker',
    git: 'Git',
    'github-actions': 'GitHub Actions',
    'clean-architecture': 'Clean Architecture',
    'clean-code': 'Clean Code',
    'rest-api': 'REST API',
    ddd: 'Domain-Driven Design',
    tdd: 'Test-Driven Development',
    'responsive-design': 'Responsive Design',
    accessibility: 'Accessibility',
    seo: 'SEO',
    vitest: 'Vitest',
    'testing-library': 'Testing Library',
    jest: 'Jest',
    github: 'GitHub',
    vscode: 'VS Code',
    figma: 'Figma',
    prisma: 'Prisma ORM',
    drizzle: 'Drizzle ORM',
    playwright: 'Playwright',
    pwa: 'PWA',
    lgpd: 'LGPD',
    vercel: 'Vercel',
    terraform: 'Terraform',
    cicd: 'CI/CD',
    ai: 'Artificial Intelligence',
    soft: {
      teamwork: 'Teamwork',
      communication: 'Communication',
      learning: 'Continuous Learning',
      mediation: 'Mediation'
    },
    category: {
      frontend: 'Frontend',
      backend: 'Backend Development',
      devops: 'DevOps',
      version: 'Version Control & DevOps',
      soft: 'Soft Skills',
      architecture: 'Architecture & Design',
      testing: 'Testing',
      tools: 'Tools'
    }
  },
  certifications: {
    view: 'View Certificate',
    title: 'Certifications',
    issuer: 'Rocketseat',
    skills: {
      title: 'Skills'
    },
    frontend: {
      title: 'Frontend Development with React'
    },
    backend: {
      title: 'Backend Development with Node.js'
    },
    fullstack: {
      title: 'Full Stack Development with React and Node.js'
    }
  },
  experience: {
    title: 'Professional Experience',
    remote: 'Remote Environment',
    role: {
      frontend: 'Frontend Developer',
      backend: 'Backend Developer',
      fullstack: 'Full Stack Developer',
      expert: 'Interaction Specialist',
      production: 'Production Assistant',
      analyst: 'Customer Service Analyst',
      analyst2: 'Transport Analyst',
      distribution: 'Distribution Assistant',
      telemarketing: 'Telemarketing Operator',
      feeder: 'Production Line Feeder',
      footwear: 'Footwear Assistant'
    },
    company: {
      self: 'Independent Development & Open Source Initiatives',
      debem: 'De Bem Tintas',
      teleperformance: 'Teleperformance',
      tempo: 'Tempo Assist',
      randstad: 'Randstad Brasil',
      jobwork: 'Agência Job Work',
      parla: 'Parla Contact Center',
      dino: 'Dino Formas',
      mantelli: 'F. Mantelli Calçados'
    },
    period: {
      debem: 'February 2021 - December 2023',
      teleperformance: 'July 2024 - November 2024',
      tempo: 'March 2015 - June 2020',
      randstad: 'September 2014 - December 2014',
      jobwork: 'May 2014 - August 2014',
      parla: 'March 2014 - April 2014',
      dino: 'July 2013 - September 2013',
      mantelli: 'February 2013 - May 2013'
    },
    location: {
      debem: 'Jaú, São Paulo',
      teleperformance: 'Remote, Brazil',
      tempo: 'São Paulo, Brazil',
      remote: 'Remote, Brazil',
      randstad: 'Cajamar, São Paulo',
      jobwork: 'Cajamar, São Paulo',
      parla: 'Barueri, São Paulo',
      dino: 'Barueri, São Paulo',
      mantelli: 'Jaú, São Paulo'
    },
    achievements: {
      frontend: {
        1: 'Development of responsive and accessible interfaces',
        2: 'Implementation of features using React and TypeScript',
        3: 'Performance and SEO optimization'
      },
      backend: {
        1: 'Development of scalable RESTful APIs',
        2: 'Implementation of Clean Architecture',
        3: 'Query and performance optimization'
      },
      fullstack: {
        1: 'Development of full-stack applications with React and Node.js',
        2: 'PWA implementation with offline-first architecture',
        3: 'Performance and SEO optimization in React applications'
      },
      teleperformance: {
        0: 'Conflict mediation between buyers and sellers',
        1: 'Customer service with empathy and problem resolution',
        2: 'Negotiation and assertive communication'
      },
      debem: {
        0: 'Production of civil construction finishes',
        1: 'Quality control and standardization',
        2: 'Teamwork and attention to detail'
      },
      tempo: {
        0: 'Customer service for Tokyo Marine insurance',
        1: 'Claims analysis and insurance processes',
        2: 'Teamwork and analytical reports'
      },
      randstad: {
        0: 'Product sorting at the distribution center'
      },
      jobwork: {
        0: 'Loading and unloading logistics'
      },
      parla: {
        0: 'Insurance sales over the phone'
      },
      dino: {
        0: 'Production of construction molds'
      },
      mantelli: {
        0: 'Footwear assembly on production line'
      }
    },
    metrics: {
      title: 'Key Metrics',
      teleperformance: {
        0: '95% customer satisfaction',
        1: 'Resolved 500+ monthly tickets',
        2: 'Average response time < 2 hours'
      }
    },
    skills: {
      title: 'Skills'
    }
  },
  projects: {
    loading: 'Loading projects...',
    error: 'Error loading projects',
    empty: 'No projects found for this profile',
    title: 'Projects',
    view: 'View project',
    source: 'View source code on GitHub',
    lastUpdate: 'Last update: {date}',
    demo: 'Demo available',
    github: 'GitHub',
    skillsLabel: 'Technologies:',
    highlightsLabel: 'Highlights:',
    tesouros: {
      title: 'Tesouros Portal',
      description: 'Enterprise club management platform with offline-first PWA, gamification, RBAC, and LGPD compliance. Real application with active users.',
      highlight1: 'Offline-first PWA with IndexedDB synchronization',
      highlight2: 'Gamification engine with XP, levels, and achievements',
      highlight3: 'RBAC with 5 access profiles and LGPD compliance'
    },
    ignitecall: {
      title: 'IgniteCall',
      description: 'Scheduling app with Google Calendar OAuth, custom Design System, and automated CI/CD',
      highlight1: 'Google Calendar OAuth integration with real-time scheduling',
      highlight2: 'Custom Design System with reusable components',
      highlight3: 'Automated CI/CD with Codecov and testing'
    },
    devstore: {
      title: 'DevStore',
      description: 'SSR e-commerce with Stripe payments, product catalog, and responsive design',
      highlight1: 'Stripe integration for production payments',
      highlight2: 'SSR with Next.js for SEO and performance'
    },
    pizzashop: {
      title: 'Pizza Shop',
      description: 'Delivery app with automated E2E testing (Playwright) and magic link authentication',
      highlight1: 'E2E tests with Playwright and unit tests with Vitest',
      highlight2: 'Passwordless magic link authentication'
    },
    forum: {
      title: 'Forum API',
      description: 'API built with Domain-Driven Design and Clean Architecture, pure domain layer with automated tests',
      highlight1: 'DDD architecture with entities, value objects, and use cases',
      highlight2: '95%+ test coverage with Vitest'
    },
    inorbit: {
      title: 'InOrbit API',
      description: 'REST API with Fastify for weekly goal tracking',
      highlight1: 'Fastify 5 with Drizzle ORM and PostgreSQL',
      highlight2: 'Zod validation and Swagger documentation'
    },
    print: {
      link: 'Link: {url}',
      github: 'Source code: {url}'
    },
    star: {
      tooltip: 'View stargazers',
      empty: 'Be the first to star!'
    },
    link: {
      tooltip: 'Open project in new tab'
    },
    github: {
      tooltip: 'View code on GitHub'
    },
    date: {
      tooltip: 'Last update date'
    },
    skills: {
      tooltip: 'Technologies used'
    },
    highlights: {
      tooltip: 'Main features'
    }
  },
  languages: {
    portuguese: 'Portuguese',
    english: 'English',
    spanish: 'Spanish',
    title: 'Languages',
    level: {
      native: 'Native',
      intermediate: 'Intermediate'
    }
  },
  education: {
    title: 'Education',
    current_subjects: 'Current Subjects',
    future_subjects: 'Upcoming Subjects',
    degree: {
      technologist: 'Internet Systems Technology',
      btech: 'Technologist in Systems Analysis and Development',
      certification: 'Technical Certification'
    },
    institution: {
      fatec: 'Fatec Jahu - Faculty of Technology of Jaú',
      estacio: 'Estácio',
      rocketseat: 'Rocketseat'
    },
    course: {
      fullstack: 'Full Stack Developer',
      ads: 'Systems Analysis and Development',
      ignite: 'Full Stack Developer'
    },
    period: {
      estacio: 'January 2025 - July 2027',
      rocketseat: 'November 2024 - November 2026'
    },
    description: {
      estacio: {
        0: 'Technologist in Systems Analysis and Development focused on programming, databases, and software engineering'
      },
      rocketseat: {
        0: 'Full Stack training specializing in React, Node.js, TypeScript, Clean Architecture, and DevOps'
      },
      fatec: {
        1: 'Course focused on web and mobile development with emphasis on modern technologies',
        2: 'Integrative project with local companies for developing real solutions'
      }
    }
  }
};

export default translations;
